import {
  ActionTree,
  MutationTree,
  GetterTree,
  Module,
  Commit,
  Dispatch,
} from "vuex";
import { Response } from "@/types/response-type";
import { User, UserLogin, UserState } from "@/types/user-type";
import { sign_in_service, sign_up_service } from "@/services/user-service";
import { RootState } from "@/types/root-type";

const state: UserState = {
  response: { status: 400, message: "Error Cargando la información" },
};

const mutations: MutationTree<UserState> = {
  set_response(state: UserState, payload: Response): void {
    state.response = payload;
  },
};

const actions: ActionTree<UserState, RootState> = {
  sign_up_action: async (
    { commit, dispatch }: { commit: Commit; dispatch: Dispatch },
    payload: User
  ): Promise<void> => {
    dispatch("update_loading", true, { root: true });
    try {
      const response: Response = await sign_up_service(payload);
      commit("set_response", response);
    } catch (err) {
      const error = err as Error;
      commit("set_response", { status: 400, message: error.message });
    }
    dispatch("update_loading", false, { root: true });
  },
  sign_in_action: async (
    { commit, dispatch }: { commit: Commit; dispatch: Dispatch },
    payload: UserLogin
  ): Promise<void> => {
    dispatch("update_loading", true, { root: true });
    try {
      const response: Response = await sign_in_service(payload);
      if (response.data?.token)
        sessionStorage.setItem("token", response.data?.token as string);
      commit("set_response", response);
    } catch (err) {
      const error = err as Error;
      commit("set_response", { status: 400, message: error.message });
    }
    dispatch("update_loading", false, { root: true });
  },
};

const getters: GetterTree<UserState, RootState> = {
  response: (state: UserState): Response => state.response,
};

const namespaced = true;

export const user_module: Module<UserState, RootState> = {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
